module.exports = __webpack_public_path__ + "img/ES1492.18a57a78.png";